<template>
  <div class="pageContent returnToStore">
    <div class="container mt3 mb3">
      <div class="columns">
        <div class="column is-7">
          <h1 v-if="!isLoading">{{ getText('noProblem', 'general') }}</h1>
          <div v-if="!isLoading">
            <div>
              <p>{{ getText('returnToStore', 'general', true) }}</p>
            </div>
          </div>
        </div>

        <div class="column">

          <ReturnItemSummary :items="data.items" />

        </div>
      </div>
    </div>
    
    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import ErrorModal from "@/components/Modals/ErrorModal.vue";
import ReturnItemSummary from "@/components/ReturnItemSummary";

export default {
  name: 'ReturnToStore',

  components: {
    ReturnItemSummary
  },

  data()
  {
    return {
      
      isLoading: false,
      pageText: [],
      generalText: [],

      labelTextData: [],
    }
  },
  props: [
    'data',
    'returnReasons'
  ],

  mounted()
  {
    this.pageText = this.$tools.translatePage();
    this.generalText = this.$tools.translatePage('general');
    this.getLabelData();
  },

  methods:
  {
    getText(ref,general = false, getStoreName = false){
      let txtArray = general == false ? this.pageText : this.generalText;
      
      if(txtArray.length > 0){
        let t = this.$tools.renderText(txtArray,ref);
        if( t.indexOf('blue561')>-1 == true )
        {
          this.openErrorMessage(t);
        } else
        {
          if (getStoreName) {
            t = t.replace('{shopName}',this.getLabelData('shopName'));
          }
          return t;
        }
      }
    },

    openErrorMessage(errorCode)
    {
      this.$buefy.modal.open({
        parent: this,
        component: ErrorModal,
        hasModalCard: true,
        props: {
          errorCode: errorCode
        }
      });
    },

    getLabelData(key){
			let labelData = atob(this.data.label);
      let labelTextData = JSON.parse(labelData);
      return labelTextData[key];
    },


    startOver(){
      this.$emit('restart');
    },
    
  }
}
</script>

